import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableTdFn = /* @__PURE__ */ createRecipe('table-td', {}, [])

const tableTdVariantMap = {}

const tableTdVariantKeys = Object.keys(tableTdVariantMap)

export const tableTd = /* @__PURE__ */ Object.assign(memo(tableTdFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableTd',
  __getCompoundVariantCss__: tableTdFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableTdVariantKeys,
  variantMap: tableTdVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableTdVariantKeys)
  },
  getVariantProps: tableTdFn.getVariantProps,
})